module.exports = __webpack_public_path__ + "img/banner-primeblocks-dark.f4d8e558.png";